<template>
  <div class="ct-right-container mt-2">
    <div
      v-if="action === 'home'"
      class="
        h-100
        w-100
        d-flex
        flex-column
        align-items-center
        justify-content-center
      "
    >
      <div><img src="@/assets/img/hrdocuments/document-icon.svg" alt="" /></div>
      <div class="cs-bold-txt mt-4">Add / Edit Document</div>
      <div class="cf-light-txt text-center mt-2">
        Select/Create documents according to your <br />
        organizational requirements
      </div>
      <template v-if="roles.includes('PUSH_DOCUMENT')">
        <div class="bluebtn">
          <b-button
            @click="$emit('show-screen', 'add', 'custom')"
            class="acs-addBtn-modal mt-4 w-230px"
            >Add Document</b-button
          >
        </div>
        <!-- :disabled="requiredDocuments.length === 0" -->

        <!-- <div class="bluebtn">
          <b-button
            @click="$emit('show-screen', 'add', 'custom')"
            class="acs-cancelBtn-modal mt-3 w-230px"
            >Custom Documents</b-button
          >
        </div> -->
      </template>
    </div>
    <div v-else>
      <div class="d-flex align-items-center border-bottom padding-12-15">
        <img
          @click="closeForm"
          class="mr-3 pointer"
          src="@/assets/customfield/blueBackArrow.svg"
          alt=""
        />
        <span class="cs-bold-txt"
          >{{ action === "add" ? "Add" : "Edit" }} Document</span
        >
      </div>
      <AddNewDocument
        :documentData="documentData"
        :uploadData="uploadData"
        :validationObj="$v"
        :getSelectedFormatLabels="getSelectedFormatLabels"
        :action="action"
        from="addDocModule"
        :initialType="type"
        @type-changed="typeChanged"
        @change-type="$emit('change-type', $event)"
        :showLoader="showLoader"
        :requiredDocuments="requiredDocuments"
        @close-form="closeForm()"
        @select-upload="uploadData = $event"
        @add-document="addDocument"
      />
    </div>
  </div>
</template>

<script>
import AddNewDocument from "@/components/Documents/AddNewDocument.vue";
import {
  required,
  requiredIf,
  integer,
  between,
  maxLength,
} from "vuelidate/lib/validators";
import {
  editDocuments,
  postDocuments,
  uploadTemplates,
} from "@/utils/apiFunctions";
import toast from "@/components/mixin/toast";
import { mapGetters } from "vuex";

export default {
  components: {
    // SelectCustom,
    // Input,
    // UploadDocument,
    AddNewDocument,
  },
  mixins: [toast],
  props: {
    requiredDocuments: Array,
    nameList: Array,
    document: Object,
    action: String,
    type: String,
    licenseKey: String,
  },
  data() {
    return {
      showLoader: false,
      definefileformatDrop: false,
      uploadData: [],
      documentData: {
        label: "",
        controlType: "upload_file",
        placeholder: "",
        mandatory: false,
        limit: null,
        values: [],
        maxFileSize: "",
        dateTimeFormat: "",
        fileFormat: ["PDF"],
        key: "",
        fieldType: "",
        dropdown: false,
        multi: false,
        apiEndPoint: "",
        sort: false,
        sortType: null,
        filter: false,
        search: false,
        category: 1,
        seq: 1,
        hide: false,
        downloadTemplate: false,
        template: [],
        allowMultiple: false,
      },
    };
  },
  validations() {
    const validateName = (value) => {
      if (this.action === "edit") return true;
      return !this.nameList.some(
        (name) => name.toLowerCase() === value.toLowerCase()
      );
    };
    return {
      documentData: {
        key: {
          required: requiredIf(() => this.type === "predefined"),
        },
        maxFileSize: {
          required,
          integer,
          between: between(1, 20),
        },
        label: {
          required: requiredIf(() => this.type === "custom"),
          maxLength: maxLength(256),
          validateName: (value) => validateName(value),
        },
        fileFormat: {
          required: requiredIf(() => this.type === "custom"),
        },
      },
      uploadData: {
        required: requiredIf(
          () => this.type === "custom" && this.documentData.downloadTemplate
        ),
      },
    };
  },
  watch: {
    action(newValue) {
      if (newValue === "edit") {
        Object.keys(this.document).forEach((docKey) => {
          const doc = this.document[docKey];
          this.documentData[docKey] = doc;
        });
        this.uploadData = [];
        if (this.documentData.downloadTemplate) {
          this.$nextTick(() => {
            this.uploadData.push(this.documentData.templateLinks[0]);
          });
        }
      } else if (newValue === "add") {
        this.uploadData = [];
      }
    },
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  methods: {
    typeChanged(value) {
      if (value == "predefined") {
        this.documentData.fileFormat = ["PDF"];
        this.documentData.downloadTemplate = false;
        this.uploadData = [];
      }
    },
    async addDocument(differentFileFormat) {
      this.$v.documentData.$touch();
      this.$v.uploadData.$touch();
      if (
        !this.$v.documentData.$invalid &&
        !this.$v.uploadData.$invalid &&
        !differentFileFormat
      ) {
        this.showLoader = true;
        if (this.type === "predefined") {
          if (this.action === "add") {
            const matchedDoc = this.requiredDocuments.find(
              (doc) => doc.key === this.documentData.key
            );
            if (matchedDoc) {
              this.documentData.label = matchedDoc.label;
            }
            this.documentData.fieldType = "predefinedField";
            this.documentData.placeholder = "Upload " + this.documentData.label;
            this.postDocuments();
          } else if (this.action === "edit") {
            this.editDocuments();
          }
        } else if (this.type === "custom") {
          if (this.action === "add") {
            this.documentData.placeholder = "Upload " + this.documentData.label;
            this.documentData.fieldType = "customField";
            this.generateKey();
          }
          if (this.documentData.downloadTemplate) {
            await this.uploadTemplates();
          }
          if (this.action === "add") {
            this.postDocuments();
          } else if (this.action === "edit") {
            this.editDocuments();
          }
        }
      }
    },
    async postDocuments() {
      try {
        let payload = {
          parentID: 6,
          field: this.documentData,
        };
        let res = await postDocuments(payload);
        if (res.status === 200) {
          this.closeForm();
          this.dynamicToast(
            "success",
            "Created Sucessfully",
            "Document has been created successfully."
          );
          this.$emit("refresh-table");
        } else {
          this.errorModal("Something went wrong!");
        }
      } catch (error) {
        console.error(error);
        this.errorModal("Something went wrong!");
      } finally {
        this.showLoader = false;
      }
    },
    async editDocuments() {
      try {
        if (!this.documentData.downloadTemplate)
          this.documentData.template =
            this.documentData.templateLinks =
            this.uploadData =
              [];
        let payload = {
          parentID: 6,
          key: this.documentData.key,
          field: this.documentData,
        };
        let res = await editDocuments(payload);
        if (res.status === 200) {
          this.closeForm();
          this.dynamicToast(
            "success",
            "Updated Sucessfully",
            "Document has been updated successfully."
          );
          this.$emit("refresh-table");
        } else {
          this.errorModal("Something went wrong!");
        }
      } catch (error) {
        console.error(error);
        this.errorModal("Something went wrong!");
      } finally {
        this.showLoader = false;
      }
    },
    async uploadTemplates() {
      try {
        let form = new FormData();
        form.append("file", this.uploadData);
        form.append(
          "path",
          `${this.licenseKey}/onboardingTemplates/${this.documentData.key}`
        );

        let res = await uploadTemplates(form);
        if (res.status === 200) {
          this.documentData.template = [];
          this.documentData.template.push(res.data.data.file_path);
        }
      } catch (error) {
        console.error(error);
      }
    },
    selectFileFormat(i) {
      for (let j of i.value) {
        let ind = this.documentData.fileFormat.indexOf(j);
        if (ind != -1) {
          this.documentData.fileFormat.splice(ind, 1);
        } else {
          this.documentData.fileFormat.push(j);
        }
      }
    },
    checkIncludes(i) {
      return i.value.every((element) =>
        this.documentData.fileFormat.includes(element)
      );
    },
    hideFileFormatDropdown() {
      this.definefileformatDrop = false;
    },
    getSelectedFormatLabels(arr1) {
      let arr = [...arr1];
      for (let i in arr) {
        if (arr[i] == "DOC") {
          arr[i] = "DOC and DOCX";
          let ind = arr.indexOf("DOCX");
          arr.splice(ind, 1);
        } else if (arr[i] == "PPT") {
          arr[i] = "PPT and PPTX";
          let ind = arr.indexOf("PPTX");
          arr.splice(ind, 1);
        } else if (arr[i] == "XLS") {
          arr[i] = "XLS and XLSX";
          let ind = arr.indexOf("XLSX");
          arr.splice(ind, 1);
        } else if (arr[i] == "TTF") {
          arr[i] = "TTF and TIF";
          let ind = arr.indexOf("TIF");
          arr.splice(ind, 1);
        }
      }
      return arr.join(" + ");
    },
    generateKey() {
      this.documentData.key =
        "CUSTFIELD" +
        "_" +
        "6" +
        "_" +
        this.documentData.label.replace(/ /g, "_") +
        "_" +
        this.getRandomKey();
    },
    getRandomKey() {
      const charset =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let key = "";
      for (let i = 0; i < 8; i++) {
        const randomIndex = Math.floor(Math.random() * charset.length);
        key += charset[randomIndex];
      }
      return key;
    },
    closeForm() {
      this.documentData = {
        label: "",
        controlType: "upload_file",
        placeholder: "",
        mandatory: false,
        limit: null,
        values: [],
        maxFileSize: "",
        dateTimeFormat: "",
        fileFormat: ["PDF"],
        key: "",
        fieldType: "",
        dropdown: false,
        multi: false,
        apiEndPoint: "",
        sort: false,
        sortType: null,
        filter: false,
        search: false,
        category: 1,
        seq: 1,
        hide: false,
        downloadTemplate: false,
        template: [],
        allowMultiple: false,
      };
      this.$v.documentData.$reset();
      this.$emit("show-screen", "home", "predefined");
    },
  },
};
</script>

<style scoped>
.padding-12-15 {
  padding: 12px 15px;
}
.w-230px {
  width: 230px;
}
.content-box {
  background: #d0d5dd !important;
}
.content-height {
  height: 39px !important;
}
.content-bg {
  background-color: #f9f9f9;
}
</style>
